"use client";

import { cn } from "@/lib/utils";

interface ImageBackgroundProps {
  staticImageUrl: string;
  className?: string;
  backdropClassName?: string;
}

export function ImageBackground({
  staticImageUrl,
  className,
  backdropClassName,
}: ImageBackgroundProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-0 pointer-events-none min-h-lvh overflow-hidden",
        className,
      )}
    >
      <div
        className="absolute inset-0 h-full w-full bg-cover bg-center animate-in fade-in duration-1000"
        style={{
          backgroundImage: `url('${staticImageUrl}')`,
        }}
      />
      <div className={cn("absolute inset-0 bg-black/30", backdropClassName)} />
    </div>
  );
}
